import { render, staticRenderFns } from "./DocumentAPIGetDetail.vue?vue&type=template&id=5efc3c0c&scoped=true&"
import script from "./DocumentAPIGetDetail.vue?vue&type=script&lang=js&"
export * from "./DocumentAPIGetDetail.vue?vue&type=script&lang=js&"
import style0 from "./DocumentAPIGetDetail.vue?vue&type=style&index=0&id=5efc3c0c&prod&scoped=true&lang=css&"
import style1 from "./DocumentAPIGetDetail.vue?vue&type=style&index=1&id=5efc3c0c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efc3c0c",
  null
  
)

export default component.exports